import japanPrefectures from "@/assets/data/japan-prefectures.json";

export const JAPAN_COUNTRY_OPTIONS = [
  {
    label: "日本",
    value: "日本",
  },
];

export const JAPAN_PREFECTURE_LIST = japanPrefectures;

export const JAPAN_PREFECTURE_OPTIONS = japanPrefectures.map((item) => ({
  label: item.name,
  value: item.name,
  code: item.code,
}));

export function normalizeJapanPostalCode(value) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, 7);
}

export function formatJapanPostalCode(value) {
  const digits = normalizeJapanPostalCode(value);
  if (digits.length <= 3) return digits;
  return `${digits.slice(0, 3)}-${digits.slice(3)}`;
}

export function normalizeJapanPhone(value) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, 11);
}

export function buildJapanFullName(form = {}) {
  if (form.userRealname) {
    return String(form.userRealname).trim();
  }
  return [form.lastName, form.firstName].filter(Boolean).join(" ").trim();
}

export function buildJapanAddressText(form = {}) {
  return [
    form.province || form.prefecture,
    form.city,
    form.district || form.addressLine1,
    form.street,
    form.detailAddress || form.addressLine2,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
}

export function buildJapanCustomerAddress(form = {}) {
  const zipCode = normalizeJapanPostalCode(form.zipCode || form.postalCode);
  const postalCode = formatJapanPostalCode(zipCode);
  const country = form.country || "日本";
  const countryCode = form.countryCode || "JP";
  const province = form.province || form.prefecture || "";
  const district = form.district || form.addressLine1 || "";
  const street = form.street || "";
  const detailAddress = String(
    form.detailAddress || form.addressLine2 || ""
  ).trim();
  const userMobile = normalizeJapanPhone(form.userMobile || form.phone);

  return {
    countryCode,
    country,
    zipCode,
    postalCode,
    province,
    city: form.city || "",
    district,
    street,
    detailAddress,
    userRealname: buildJapanFullName(form),
    userMobile,
    mobileNo: userMobile,
  };
}
